
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ClickOutside from '../directives/click-outside';
import NButton from './NButton.vue';
import NButtonsDoubleGroup from './NButtonsDoubleGroup.vue';
import { NButtonSize, NButtonSizes, NButtonType, NButtonTypes } from './types';

@Options({
  name: 'NDoubleButton',
  components: { NButton, NButtonsDoubleGroup },
  directives: {
    ClickOutside
  }
})
export default class NDoubleButton extends Vue {
  @Prop({ type: String, default: NButtonTypes.Primary })
  type?: NButtonType;

  @Prop({ type: String, default: NButtonSizes.Normal })
  size?: NButtonSize;

  @Prop({ type: [Number, String] })
  readonly counter?: number | string;

  @Prop({ type: Boolean, default: false })
  readonly disableButton?: boolean;

  dropdownStatus = false;

  triggerDropdown() {
    this.dropdownStatus = !this.dropdownStatus;
    this.$emit('toggle', this.dropdownStatus);
  }

  closeDropdown() {
    this.dropdownStatus = false;
  }
}
